export default function({ dispatch, commit }, credentials) {
    commit('startedAuthentication')

    // POST /auth/login
    return dispatch('post', {
        url: '/auth/join/initiate',
        data: credentials
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        commit('initiatedJoin', response)
        return response
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
